// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Esdp","selects":"Documents_selects__tKleN"};